import React, { useContext, useEffect, useState, useMemo, useCallback, memo, startTransition, useRef } from "react";
import { Badge, Form, Modal } from "react-bootstrap";
import UserAvatar from "../../components/UserAvatar";
import { DE } from "../../Languages/DE";
import { EN } from "../../Languages/EN";
import LanguageContext from "../../helper/LanguageContext";
import { withRouter } from "react-router-dom";
import { Scrollbars } from "react-custom-scrollbars";
import { callAPI } from "../../helper/apiUtils";
import { BASE_URL, KJUUP_COLORS } from "../../helper/constants";
import $ from "jquery";
import {
  FORWARD_MESSAGE,
  GROUPS,
  GROUPS_BOTTOM,
  MESSAGE_IDS,
  OPEN_BOTTOM_CHATS,
  OPEN_CHATS,
  UPDATE_GROUP_MESSAGE,
  DRAFT_MESSAGES,
  IS_OPEN_BY_OWNER,
  ALL_BADGE_COUNT,
  FROM_FROROIEGN_PROFILE,
  TOGGLE_CHAT,
  SET_DEEPLINK_DATA,
  SET_DEEPLINK_LOADING,
  SET_LOADER,
} from "../../store";
import { connect, useDispatch, useSelector } from "react-redux";
import { ReactComponent as AddOneToOne } from "../../Icons/AddOneToOne.svg";
import AddOneToOneUser from "./AddOneToOneUser";
import { AiOutlineFile } from "react-icons/ai";
import { BsFillPlusCircleFill } from "react-icons/bs";
import { IoMdImage } from "react-icons/io";
import { MdVideocam } from "react-icons/md";
import { $crud } from "../../helper/CrudFactory";
import { $user } from "../../helper/UserFactory";
import _ from "lodash";
import { Rings } from "react-loader-spinner";
import { SocketContext } from "../../context/socket";
import { stripMarkdown, truncateGroupName } from "../../utils/conversationUtils";
import { getDraftPreviewText } from "../../utils/draftMessages";
import MarkdownPreview from "../../components/MarkdownPreview";
import { translateMessagesBatch } from "../../utils/translationUtils";
import "./chat.css";

const renderThumb = ({ style, ...props }) => {
  const thumbStyle = {
    borderRadius: 6,
    backgroundColor: "rgba(var(--kjuup-accent-rgb), 0.8)",
  };
  return <div style={{ ...style, ...thumbStyle }} {...props} />;
};

const CustomScrollbars = (props) => (
  <Scrollbars
    renderThumbHorizontal={renderThumb}
    renderThumbVertical={renderThumb}
    {...props}
  />
);

// Memoized UserListItem component to prevent unnecessary re-renders
const UserListItem = memo(({ 
  group, 
  index, 
  user, 
  storedDraftMessage, 
  forwardMessage, 
  forOpenChatId, 
  onChatClick, 
  onSelectIds,
  onMuteClick,
  translatedName
}) => {
  const { isGerm, strings } = useContext(LanguageContext);
  // Memoize expensive calculations
  const chatUser = useMemo(() => 
    group.users.filter((u) => u.id !== user?.id), 
    [group.users, user?.id]
  );
  
  const isBlock = useMemo(() => chatUser[0]?.isBlock || false, [chatUser]);
  const isDeativated = useMemo(() => !chatUser[0]?.isActive || false, [chatUser]);
  
  // Memoize draft message check
  const draftMessage = useMemo(() => 
    storedDraftMessage.find((m) => m.group === group.id),
    [storedDraftMessage, group.id]
  );

  const handleClick = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!forwardMessage && !group.isOpened) {
      onChatClick(group, index);
    }
  }, [forwardMessage, onChatClick, group, index]);

  const handleSelect = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    onSelectIds(group.id, group);
  }, [onSelectIds, group]);

  const handleMuteClick = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    const currentUserInGroup = group.users.find((u) => u.id === user?.id);
    onMuteClick(group, !(currentUserInGroup?.isMute));
  }, [onMuteClick, group, user?.id]);

  // Get current user's mute status
  const currentUserInGroup = useMemo(() => 
    group.users.find((u) => u.id === user?.id),
    [group.users, user?.id]
  );

  return (
    <div
      key={group.id}
      className={`company_centact ${group.isOpened ? "active-project" : ""} chat-list-item${group?.isDeactivated ? " chat-list-item--deactivated" : ""}`}
      onClick={handleClick}
    >
      <div className="website pointer chat-list-item__row">
        <div className="chat-list-item__main">
          <div className="website_img">
            <UserAvatar
              width={30}
              height={30}
              src={
                group.avatar
                  ? BASE_URL + group.avatar
                  : process.env.PUBLIC_URL + "/assets/img/profile.png"
              }
              alt="User avatar"
              fallbackSrc={process.env.PUBLIC_URL + "/assets/img/head.svg"}
            />
            {!currentUserInGroup?.isMute && group.unseenChatCount > 0 ? (
              <Badge pill className="chat-list__badge">{group.unseenChatCount}</Badge>
            ) : (
              ""
            )}
          </div>
          <div className="details-company chat-list-item__details">
            <h5 className="header-text-overflow">{truncateGroupName(stripMarkdown(translatedName || group.name))}</h5>
            {!isBlock &&
              !isDeativated &&
              !draftMessage && (
                <div className="m-0 chat-list-item__preview">
                  {group.lastReactionEmoji && group.lastReactionSenderName ? (
                    <p className="m-0 reaction-preview text-truncate">
                      {group.lastReactionSenderName} {strings.reacted_with || "reacted with"} {group.lastReactionEmoji}
                    </p>
                  ) : (
                    !group.lastMessageDeleted && group.lastMessageType === "simple" && (
                      <div className="m-0 last-message-preview text-truncate">
                        {group.lastMessage && (
                          <MarkdownPreview
                            text={group.lastMessage.replace(/<br\s*[/]?>/gi, " ")}
                            strings={strings}
                            className="message-preview-text"
                          />
                        )}
                      </div>
                    )
                  )}
                  {!group.lastReactionEmoji && group.lastMessageType === "doc" && !group.lastMessageDeleted && (
                    <p className="m-0 text-truncate">
                      <AiOutlineFile />
                    </p>
                  )}
                  {!group.lastReactionEmoji && group.lastMessageType === "video" && !group.lastMessageDeleted && (
                    <p className="m-0 text-truncate">
                      <MdVideocam /> {group.lastMessage}
                    </p>
                  )}
                  {!group.lastReactionEmoji && group.lastMessageType === "image" && !group.lastMessageDeleted && (
                    <p className="m-0 text-truncate">
                      <IoMdImage />
                    </p>
                  )}
                </div>
              )}
            {draftMessage && !isBlock ? (
              <div className="draft-message m-0 chat-list-item__preview">
                <p className="m-0 text-truncate">
                  {strings.draft_prefix || "Draft:"} {getDraftPreviewText(draftMessage.message)}
                </p>
              </div>
            ) : null}
            {isBlock ? (
              <p className="m-0 text-truncate">
                {strings.you_have_blocked}
              </p>
            ) : <></>}
            {isDeativated ? (
              <p className="m-0 text-truncate">
                {strings.a_Da}
              </p>
            ) : <></>}
          </div>
        </div>
        <div className="chat-list-item__actions">
          {!forwardMessage && !isDeativated && !isBlock && (
            <div
              onClick={handleMuteClick}
              className="chat-list-item__mute"
            >
              {currentUserInGroup?.isMute ? (
                <span
                  className="material-symbols-outlined chat-list-item__mute-icon"
                  title={strings.unmute}
                >
                  notifications_off
                </span>
              ) : (
                <span
                  className="material-symbols-outlined chat-list-item__mute-icon"
                  title={strings.mute}
                >
                  notifications_active
                </span>
              )}
            </div>
          )}
          {forwardMessage &&
            group.id !== forOpenChatId &&
            !isDeativated && (
              <div className="chat-list-item__select">
                <label className="container_checkbox m-0">
                  <input
                    type="checkbox"
                    onClick={handleSelect}
                  />
                  <span className="checkmark chat-list-item__checkmark"></span>
                </label>
              </div>
            )}
        </div>
      </div>
    </div>
  );
});

// Add display name for better debugging
UserListItem.displayName = 'UserListItem';

function Chat(props) {
  const user = $user.get();
  const { isGerm, strings, language } = React.useContext(LanguageContext);
  const [search, setSearch] = useState("");
  const [groups, setGroups] = useState([]);
  const [allGroups, setAllGroups] = useState([]);
  const [chatUser, setChatUser] = useState(false);
  const [action, setAction] = useState("");
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [storedDraftMessage, setStoredDraftMessage] = useState([]);
  const { unSeenAllCount } = useSelector((state) => state);
  const [deUSer, setDEUser] = useState([]);
  const [getting, setGetting] = useState(false);
  const Socket = useContext(SocketContext);
  const [viewLoader, setViewLoader] = useState(false);
  const fromForeignprofile = useSelector(
    (state) => state.fromForeignprofile
  );
  const isDesktop = useSelector((state) => state.isDeskTopResolution);
  const deeplinkData = useSelector(state => state.deeplinkData)
  const dispatch = useDispatch()
  const isSelectingRef = useRef(false)

  const translateRoomAndGroupNames = useSelector((state) => state.translateRoomAndGroupNames);
  const [translatedGroupNames, setTranslatedGroupNames] = useState({});

  useEffect(() => {
    if (!translateRoomAndGroupNames) {
      setTranslatedGroupNames({});
      return;
    }
    if (!groups || groups.length === 0) return;

    let cancelled = false;
    const lang = (localStorage.getItem('language') || language || 'en').split('-')[0];

    const translateNames = async () => {
      const batchItems = groups
        .filter((group) => group.name)
        .map((group) => ({ id: String(group.id), message: stripMarkdown(group.name) }));
      if (batchItems.length === 0) return;
      const results = await translateMessagesBatch(batchItems, lang);
      if (cancelled) return;
      for (const r of results) {
        const group = groups.find((g) => String(g.id) === String(r.id));
        if (group && r.translatedMessage && r.translatedMessage !== stripMarkdown(group.name)) {
          setTranslatedGroupNames((prev) => prev[group.id] === r.translatedMessage ? prev : { ...prev, [group.id]: r.translatedMessage });
        }
      }
    };

    translateNames();
    return () => { cancelled = true; };
  }, [translateRoomAndGroupNames, groups, language]);

  // Mute/Unmute state
  const [showMuteConfirm, setShowMuteConfirm] = useState(false);
  const [selectedGroupForMute, setSelectedGroupForMute] = useState(null);
  const [isMuteAction, setIsMuteAction] = useState(true);
  const get = async (fromForeignprofile) => {
    setGroups([]);
    setDEUser([]);
    setGetting(true);
    const { data } = await callAPI("/group", {}, "GET");
    if (data.status) {
      setGetting(false);
      if (!fromForeignprofile || fromForeignprofile == 'pageLoad') {
        if (deeplinkData) {
          let { chatGroupId } = deeplinkData
          const updateGroup = await data.groups.map((g, i) => {
            if (g.id == chatGroupId) {
              return {
                ...g,
                isOpened: true,
                key: i + 1,
                originalMessage: g.lastMessage,
                messageLng: "en",
                isBlock: g.name.trim()
                  ? !!g.users.find((u) => u.id !== user?.id)?.isBlock
                  : false,
              };
            } else {
              return {
                ...g,
                isOpened: false,
                key: i + 1,
                originalMessage: g.lastMessage,
                messageLng: "en",
                isBlock: g.name.trim()
                  ? !!g.users.find((u) => u.id !== user?.id)?.isBlock
                  : false,
              };
            }
          });
          let updateDataNew = updateGroup.sort((a, b) => {
            return a.isLeave - a.isLeave
          });
          setGroups(updateDataNew);
          setAllGroups(updateDataNew);
          let recordToSelectFromServerListIndex = updateDataNew.findIndex((e) => e.id == chatGroupId)
          const selectedRecord = recordToSelectFromServerListIndex !== -1 ? updateDataNew[recordToSelectFromServerListIndex] : null;
          if (selectedRecord) {
            props.updateOpenChats([selectedRecord]);
          }
          props.updateGroups(updateDataNew);
          console.log('chatGroupId', chatGroupId, selectedRecord)
          requestAnimationFrame(() => {
            if (selectedRecord && data.groups.findIndex((e) => e.id == chatGroupId) !== -1) {
              chat_click(selectedRecord, recordToSelectFromServerListIndex)
            }
            dispatch({ type: SET_DEEPLINK_LOADING, loading: false })
          });
        } else {
          const updateData = data.groups.map((building, i) => {
            return {
              ...building,
              key: i + 1,
              isOpened: deeplinkData ? false : (i == 0 ? isDesktop ? true : false : false),
              originalMessage: building.lastMessage,
              messageLng: "en",
              isBlock: building.name.trim()
                ? !!building.users.find((u) => u.id !== user?.id)?.isBlock
                : false,
            };
          });
          let updateDataNew = updateData.sort((a, b) => {
            return a.isLeave - a.isLeave
          });
          setGroups(updateDataNew);
          setAllGroups(updateDataNew);
          if (isDesktop)
            props.updateOpenChats([updateDataNew[0]]);
          props.updateGroups(updateDataNew);
        }
      }
      else {
        let recordToSelectFromServerList = { ...fromForeignprofile }
        const updateGroup = await data.groups.map((g, i) => {
          if (g.id === recordToSelectFromServerList.id) {
            return {
              ...g,
              isOpened: true,
              key: i + 1,
              originalMessage: g.lastMessage,
              messageLng: "en",
              isBlock: g.name.trim()
                ? !!g.users.find((u) => u.id !== user?.id)?.isBlock
                : false,
            };
          } else {
            return {
              ...g,
              isOpened: false,
              key: i + 1,
              originalMessage: g.lastMessage,
              messageLng: "en",
              isBlock: g.name.trim()
                ? !!g.users.find((u) => u.id !== user?.id)?.isBlock
                : false,
            };
          }
        });
        let updateDataNew = updateGroup.sort((a, b) => {
          return a.isLeave - a.isLeave
        });
        let recordToSelectFromServerListIndex = updateDataNew.findIndex((e) => e.id == recordToSelectFromServerList.id)
        setGroups(updateDataNew);
        setAllGroups(updateDataNew);
        props.updateOpenChats([updateDataNew[recordToSelectFromServerListIndex]]);
        props.updateGroups(updateDataNew);
      }
    }
  };

  useEffect(() => {
    if (fromForeignprofile) {
      setGetting(true)
      get(fromForeignprofile)
    }
    dispatch({ type: FROM_FROROIEGN_PROFILE, payload: false })
  }, [fromForeignprofile])

  // Handle deeplink data on mount - if component mounts with deeplink data, load the chat
  useEffect(() => {
    if (deeplinkData?.chatGroupId && !getting && groups.length === 0) {
      console.log('Chat component mounted with deeplink data, loading chat:', deeplinkData.chatGroupId);
      setGetting(true);
      get('pageLoad');
    }
  }, []) // Only run on mount


  useEffect(() => {
    if (props.groups && props.groups.length > 0) {
      let _Temp = [...props.groups];
      if (fromForeignprofile) {
        _Temp[0].isOpened = false
      }
      let isDeactivatedU = [];
      for (let obj of _Temp) {
        if (obj.users) {
          const chatUser = obj.users.filter((u) => u.id !== user?.id);
          if (chatUser) {
            if (chatUser[0]?.isDeactivated) {
              obj.isDeactivated = true;
              isDeactivatedU.push(obj);
            } else {
              obj.isDeactivated = false;
            }
          }
        }
      }
      const localStoredMessage = JSON.parse(localStorage.getItem("draftMessage"))
        ? JSON.parse(localStorage.getItem("draftMessage"))
        : [];
      setStoredDraftMessage(localStoredMessage);
      props.updateDraftMessages(localStoredMessage);
      if (props.groups.length < 1) {
      } else {
        let final = [];
        for (let obj of props.groups) {
          let ind = isDeactivatedU.findIndex((e) => e.id == obj.id);
          if (ind == -1) {
            final.push(obj);
          }
        }
        const groupList = _.uniqBy(final, "id");
        
        // Only update if the groups have actually changed (not just isOpened flags)
        // Helper function to get isBlock status from users array
        const getIsBlock = (group) => {
          const otherUser = group.users?.find(u => u.id !== user?.id);
          return otherUser?.isBlock || false;
        };
        
        setGroups(prevGroups => {
          // Check if this is just a props update from our own state changes
          if (prevGroups.length === groupList.length && 
              prevGroups.every((prev, index) => 
                prev.id === groupList[index].id && 
                prev.lastMessage === groupList[index].lastMessage &&
                prev.unseenChatCount === groupList[index].unseenChatCount &&
                getIsBlock(prev) === getIsBlock(groupList[index])
              )) {
            // This is likely our own state update, don't override
            return prevGroups;
          }
          return groupList;
        });
        setDEUser(isDeactivatedU);
        setAllGroups(prevAllGroups => {
          // Same check for allGroups
          if (prevAllGroups.length === groupList.length && 
              prevAllGroups.every((prev, index) => 
                prev.id === groupList[index].id && 
                prev.lastMessage === groupList[index].lastMessage &&
                prev.unseenChatCount === groupList[index].unseenChatCount &&
                getIsBlock(prev) === getIsBlock(groupList[index])
              )) {
            return prevAllGroups;
          }
          return groupList;
        });
      }
    }
  }, [props.groups, fromForeignprofile, user?.id]);

  // Optimized search with useMemo and debouncing
  const filteredGroups = useMemo(() => {
    if (!search.trim() || !user?.id) {
      return allGroups;
    }
    
    const searchValue = search.toLowerCase().trim();
    const searchWords = searchValue.split(/\s+/);
    
    return allGroups.filter((group) => {
      const chatUser = group.users.find((u) => u.id !== user.id);
      if (!chatUser) return false;
      
      const firstName = chatUser.firstName?.toLowerCase() || '';
      const lastName = chatUser.lastname?.toLowerCase() || '';
      const fullName = `${firstName} ${lastName}`.trim();
      
      // Fast exact match check first
      if (firstName.startsWith(searchValue) || lastName.startsWith(searchValue)) {
        return true;
      }
      
      // Check if all search words are contained in the full name
      return searchWords.every(word => fullName.includes(word));
    });
  }, [allGroups, search, user?.id]);

  //Search Project - optimized with useCallback
  const searchUser = useCallback((e) => {
    const value = e.target.value.trim();
    setSearch(value);
  }, []);

  const setDraftMessage = (message, group) => {
    message = message.trim();
    if (message) {
      const msgObject = {
        userId: user?.id,
        message: message,
        messageType: "simple",
        group: group.id,
      };

      let allMessages = props.draftMessages;
      const foundIndex = allMessages.findIndex(
        (msg) => msg.userId === user?.id && msg.group === group.id
      );
      console.log(foundIndex);
      if (foundIndex > -1) {
        console.log(allMessages[foundIndex]);
        allMessages[foundIndex] = {
          ...allMessages[foundIndex],
          message: message,
        };
      } else {
        allMessages = [...allMessages, msgObject];
      }
      console.log(allMessages);
      localStorage.setItem("draftMessage", JSON.stringify(allMessages));
      props.updateDraftMessages(allMessages);
    }
  };

  // Optimized chat click handler - fixed race condition
  const chat_click = useCallback(async (group, index) => {
    // Prevent multiple rapid clicks and race conditions
    // Also check if group is valid (not undefined)
    if (!group || group.isOpened || isSelectingRef.current) return;
    
    isSelectingRef.current = true;
    // Only toggle chat sidebar if NOT coming from deeplink/profile
    // When coming from deeplink, we want the sidebar to stay hidden
    if (!deeplinkData?.chatGroupId) {
      dispatch({ type: TOGGLE_CHAT });
    }
    
    try {
      // Do not decrement the SideNav badge on click — Conversation
      // subscribe + /badge/count clear it once messages are actually read.
      
      // Update groups state using functional updates to avoid stale closures
      setGroups(prevGroups => {
        const updateGroup = prevGroups.map((g) => ({
          ...g,
          isOpened: g.id === group.id,
          unseenChatCount: g.id === group.id ? 0 : g.unseenChatCount
        }));
        
        // Update allGroups with the same data
        setAllGroups(updateGroup);
        
        // Update Redux store
        props.updateGroups(updateGroup);
        props.updateOpenChats([{ ...group, isOpened: true, unseenChatCount: 0 }]);
        props.isOwnerOpenProject(false);
        
        return updateGroup;
      });
      
      // Clear deeplink data if needed
      if (group.id !== deeplinkData?.chatGroupId) {
        dispatch({ type: SET_DEEPLINK_DATA, payload: null });
      }
    } finally {
      // Reset the selection flag after a short delay
      setTimeout(() => {
        isSelectingRef.current = false;
      }, 100);
    }
  }, [unSeenAllCount, props, dispatch, deeplinkData]);



  const handleUserAction = () => {
    setAction("top");
    setChatUser(true);
  };

  const handleForward = async () => {
    const countGroups = selectedGroups.length;
    if (countGroups > 0) {
      setViewLoader(true);
      const { data } = await callAPI("/message/forward", {}, "POST", {
        group: selectedGroups,
        id: props.messageIds,
      });
      if (data.status) {
        $crud.notify({
          type: "success",
          message: strings.message_forwarded,
        });
      }
      props.updateForwardMessage(false);
      props.updateMessageIds([]);
      await selectedData?.map((itm) => chat_click(itm));
      await setSelectedData([]);
      await setSelectedGroups([]);
      setViewLoader(false);
    } else {
      $crud.notify({
        type: "error",
        message: strings.please_select_group_to_forward,
      });
    }
  };
  const handleCancel = () => {
    props.updateForwardMessage(false);
    props.updateOpenBottomChats([]);
  };

  const selectIds = useCallback((id, group) => {
    setSelectedGroups(prev => {
      const isSelected = prev.includes(id);
      if (isSelected) {
        return prev.filter((g) => g !== id);
      } else {
        return [...prev, id];
      }
    });
    
    setSelectedData(prev => {
      const isSelected = prev.some((g) => g?.id === group?.id);
      if (isSelected) {
        return prev.filter((g) => g?.id !== group?.id);
      } else {
        return [...prev, group];
      }
    });
  }, []);

  // Handle mute/unmute confirmation
  const handleMuteUnmuteClick = useCallback((group, mute) => {
    setSelectedGroupForMute(group);
    setIsMuteAction(mute);
    setShowMuteConfirm(true);
  }, []);

  const confirmMuteUnmute = async () => {
    if (!selectedGroupForMute) return;

    dispatch({ type: SET_LOADER, loader: true });
    try {
      const { data } = await callAPI(
        "/group/muteUnmuteChat",
        {
          mute: isMuteAction,
          group: selectedGroupForMute.id,
        },
        "PUT"
      );

      if (data.status) {
        $crud.notify({
          type: "success",
          message: isMuteAction 
            ? strings.chat_muted_successfully
            : strings.chat_unmuted_successfully,
        });

        // Update local groups state - update isMute for current user in users array
        const updatedGroups = groups.map((g) => {
          if (g.id === selectedGroupForMute.id) {
            const updatedUsers = g.users.map((u) => 
              u.id === user.id ? { ...u, isMute: isMuteAction } : u
            );
            return { ...g, users: updatedUsers };
          }
          return g;
        });
        
        setGroups(updatedGroups);
        setAllGroups(updatedGroups);
        props.updateGroups(updatedGroups);
      } else {
        $crud.notify({
          type: "error",
          message: data.message || (strings.something_went_wrong),
        });
      }
    } catch (error) {
      $crud.notify({
        type: "error",
        message: strings.something_went_wrong,
      });
    } finally {
      dispatch({ type: SET_LOADER, loader: false });
      setShowMuteConfirm(false);
      setSelectedGroupForMute(null);
    }
  };

  const cancelMuteUnmute = () => {
    setShowMuteConfirm(false);
    setSelectedGroupForMute(null);
  };


  useEffect(() => {
    setStoredDraftMessage(props.draftMessages);
  }, [props.draftMessages]);

  // Early return if user is not available (after all hooks)
  if (!user) {
    return <div>Loading...</div>;
  }

  return (
    <React.Fragment>
      <div
        className={`w-300 my_project py-0 immoanimation-enter-done user_list_main_box common_box_user_list chat-list ${props.isOpenByOwner ? "chat-list--owner" : "chat-list--column"}`}
      >
        {viewLoader && (
          <div className="website_loader">
            <div className="loader" />
          </div>
        )}
        {getting && (
          <div className="chat-list__loading">
            <div className="chat-list__loading-inner">
              <Rings
                height="100"
                width="100"
                color="var(--kjuup-accent)"
                radius="6"
                wrapperStyle={{ flex: 1 }}
                wrapperClass=""
                visible={true}
                ariaLabel="rings-loading"
              />
            </div>
          </div>
        )}
        {!chatUser && (
          <div className="kj-flex-1">
            <div className="main_heading chat-list__heading">
              {strings.Chats}
              <div className="circle_icon_div">
                <BsFillPlusCircleFill fill={KJUUP_COLORS.base_color} size={20} className="chat-list__add-icon" onClick={handleUserAction} />
              </div>
            </div>
            <div className="search">
              <Form.Group controlId="exampleForm.ControlInput1">
                <Form.Control
                  autocomplete="off"
                  type="search"
                  onChange={(e) => searchUser(e)}
                  placeholder={strings.search}
                />
              </Form.Group>
            </div>
          </div>
        )}

        {!chatUser && !getting && (
          <CustomScrollbars
            autoHide
            autoHideTimeout={200}
            autoHideDuration={200}
            className="bottom-bar"
          >
            <div
              className="company_services test123 m-0 chat_services kj-flex-1"
            >
              {filteredGroups?.map((group, index) => (
                <UserListItem
                  key={group.id}
                  group={group}
                  index={index}
                  user={user}
                  storedDraftMessage={storedDraftMessage}
                  forwardMessage={props.forwardMessage}
                  forOpenChatId={props.forOpenChatId}
                  onChatClick={chat_click}
                  onSelectIds={selectIds}
                  onMuteClick={handleMuteUnmuteClick}
                  translatedName={translatedGroupNames[group.id]}
                />
              ))}
              {deUSer &&
                !search &&
                deUSer.map((group, index) => (
                  <div
                    key={index}
                    className={`company_centact ${group.isOpened ? "active-project" : ""
                      } chat-list__deleted-item${group?.isDeactivated ? " chat-list__deleted-item--deactivated" : ""}`}
                    onClick={(e) => chat_click(group)}
                  >
                    <a className="website pointer">
                      <div className="website_img">
                        <img
                          width={30}
                          height={30}
                          className="chat-list__deleted-avatar"
                          src={
                            group.avatar
                              ? BASE_URL + group.avatar
                              : process.env.PUBLIC_URL +
                              "/assets/img/profile.png"
                          }
                          alt="Generic placeholder"
                        />
                        {!(group.users?.find(u => u.id === user?.id)?.isMute) && group.unseenChatCount > 0 ? (
                          <Badge pill className="chat-list__badge">{group.unseenChatCount}</Badge>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="details-company forword-checkbox_main">
                        <div className="m-0">
                          <h5>{truncateGroupName(stripMarkdown(translatedGroupNames[group.id] || group.name))}</h5>
                          <p className="m-0 text-truncate">
                            {strings.account_deleted}
                          </p>
                        </div>
                      </div>
                    </a>
                  </div>
                ))}
            </div>
          </CustomScrollbars>
        )}

        {!chatUser && (
          <div>
            {props.forwardMessage && (
              <div
                className="forward-action-buttons chat-list__forward-actions"
              >
                <button
                  onClick={handleCancel}
                  className="kj-btn kj-btn--secondary kj-flex-1"
                >
                  {strings.cancel}
                </button>
                <button
                  onClick={handleForward}
                  className="kj-btn kj-btn--outline kj-flex-1"
                >
                  {strings.forward}
                </button>
              </div>
            )}
          </div>
        )}

        {chatUser && (
          <AddOneToOneUser
            action={action}
            hide={() => setChatUser(false)}
            afterAddUser={(data) => {
              get();
            }}
          />
        )}
      </div>

      {/* Mute/Unmute Confirmation Modal */}
      <Modal
        show={showMuteConfirm}
        onHide={cancelMuteUnmute}
        animation={false}
        centered
      >
        <Modal.Body className="modal-body-relative">
          <p>
            {isMuteAction
              ? (strings.mute_chat_confirm)
              : (strings.unmute_chat_confirm)
            }
          </p>
        </Modal.Body>
        <Modal.Footer className="chat-list__modal-footer">
          <button
            type="button"
            className="kj-btn kj-btn--outline kj-btn--on-surface"
            onClick={cancelMuteUnmute}
          >
            {strings.cancel}
          </button>
          <button
            type="button"
            className="kj-btn kj-btn--primary"
            onClick={confirmMuteUnmute}
          >
            {strings.ok}
          </button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  const {
    groups,
    groupsBottom,
    openChats,
    openBottomChats,
    forwardMessage,
    messageIds,
    updateGroupMessage,
    language,
    draftMessages,
    isOpenByOwner,
    forOpenChatId,
  } = state;
  return {
    groups: groups,
    language: language,
    groupsBottom: groupsBottom,
    openChats: openChats,
    openBottomChats: openBottomChats,
    forwardMessage: forwardMessage,
    messageIds: messageIds,
    updateGroupMessage: updateGroupMessage,
    draftMessages: draftMessages,
    isOpenByOwner,
    forOpenChatId,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    updateGroups: (groups) => dispatch({ type: GROUPS, groups: groups }),
    updateOpenChats: (chats) =>
      dispatch({ type: OPEN_CHATS, openChats: chats }),
    updateGroupsBottom: (groups) =>
      dispatch({ type: GROUPS_BOTTOM, groupsBottom: groups }),
    updateOpenBottomChats: (chats) =>
      dispatch({ type: OPEN_BOTTOM_CHATS, openBottomChats: chats }),
    updateForwardMessage: (value) =>
      dispatch({ type: FORWARD_MESSAGE, forwardMessage: value }),
    updateMessageIds: (ids) => dispatch({ type: MESSAGE_IDS, messageIds: ids }),
    updateLastMessage: (msg) =>
      dispatch({ type: UPDATE_GROUP_MESSAGE, updateGroupMessage: msg }),
    updateDraftMessages: (msg) =>
      dispatch({ type: DRAFT_MESSAGES, draftMessages: msg }),
    isOwnerOpenProject: (open) => dispatch({ type: IS_OPEN_BY_OWNER, open }),
    updateAllBadgeCount: (count) =>
      dispatch({ type: ALL_BADGE_COUNT, unSeenAllCount: count }),
    toggleChat: () => dispatch({ type: TOGGLE_CHAT }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Chat));
